import {createSlice} from  '@reduxjs/toolkit';

const initialState = {
    isloading:false,
    status:"",
    message:"",
};

const userCreateSlice = createSlice({
    name:"userCreate",
    initialState,
    reducers:{
        createPending: (state,action) =>{
            state.isloading=true;
        },
        createSuccess: (state,{payload}) =>{
            state.isloading=false;
            state.status="success";
            state.message=payload;
        },
        createFail: (state,{payload}) =>{
            state.isloading=false;
            state.status="error";
            state.message=payload.message;
        },
    }
});


const {reducer, actions} = userCreateSlice;
export const {createPending,createSuccess,createFail} =actions;
export default reducer;
